import { FormTextHeader } from '@/components/dialogs/Registration/components/FormHeader/FormTextHeader';
import type { RegistrationConfig, RegistrationTheme } from '../types';

const COMMON_REG_THEME: RegistrationTheme = {
  formMarginBottom: '24px',
};

export const COMMON_REG_CONFIG = {
  head: {
    render: () => <FormTextHeader />,
  },
  input: {
    withInsideLabel: false,
  },
  select: {
    withInsideLabel: false,
  },
  checkbox: {},
  styleScheme: null,
};

export const BASIC_REG_CONFIG: RegistrationConfig = {
  ...COMMON_REG_CONFIG,
  buttons: {
    regButton: {
      colorMode: { primary: true },
    },
    googleRegButton: {
      colorMode: { blackTransparent: true },
    },
    next: {
      colorMode: { primary: true },
    },
    back: {
      colorMode: { blackTransparent: true },
    },
  },
  withNavigationOnFirstStep: true,
  withPayments: true,
  styleScheme: COMMON_REG_THEME,
};
